import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles((theme) => ({
  required: {
    color: theme.colors.error.main,
    fontSize: 24,
    verticalAlign: 'bottom',
  },
  errorText: {
    marginLeft: 15,
  },
}));
